import React from 'react'

class Surveys extends React.Component {
    render() {
    // const {user} = this.props;
    return (
      <div style={{display: 'flex', justifyContent: 'center'}}>

          <img src="../underConstruction.png" alt=""/>

      </div>
    )
  }
}

export default Surveys;





